<template>
  <div class="Detail">
    <my_content :content="detail.content" :inputStyle="detailStyle"></my_content>
  </div>
</template>

<script>
 import MyContent from '@/components/Content.vue';
 import DetailImages from '@/components/frontpage/DetailImages.vue'
 export default {
   name: 'Detail',
   props: ['detail'],
   computed: {
     detailStyle() {
       return this.$store.state.frontpage.detail.style;
     }
   },
   components: {
     my_content: MyContent,
     detail_images: DetailImages
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Detail{
   height: 44.2vw;
   box-sizing: border-box;
   padding-top: 3vw;
   padding-bottom: 3vw;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
 }
</style>
